import { Outlet, useLocation } from "react-router-dom";
import SidebarPanel from "../components/layout/SidebarPanel";
import MobileSidebar from "../components/layout/MobileSodebar";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";

export default function MaxLayout() {
  const chat = useSelector((state) => state.chat);
  const location = useLocation();
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const sidebarTimeoutRef = useRef(null);

  const handleSidebarEnter = () => {
    if (sidebarTimeoutRef.current) clearTimeout(sidebarTimeoutRef.current);
    setSidebarExpanded(true);
  };

  const handleSidebarLeave = () => {
    sidebarTimeoutRef.current = setTimeout(() => {
      setSidebarExpanded(false);
    }, 300);
  };

  useEffect(() => {
    return () => {
      if (sidebarTimeoutRef.current) clearTimeout(sidebarTimeoutRef.current);
    };
  }, []);

  return (
    <>
      <div className="flex h-screen bg-[#F0EEF8] items-stretch overflow-hidden">
        {/* Desktop sidebar — collapsed icon strip, hover to expand overlay */}
        <div
          className="max-md:hidden relative flex-shrink-0 h-full"
          onMouseEnter={handleSidebarEnter}
          onMouseLeave={handleSidebarLeave}
        >
          {/* Collapsed strip — always visible, width animates on hover */}
          <div
            className="h-full flex flex-col items-center py-4 z-10 relative transition-all duration-300 ease-in-out"
            style={{
              width: sidebarExpanded ? "250px" : "60px",
              background: "linear-gradient(180deg, #1A0E3E 0%, #4F2A71 60%, #904DB0 100%)",
            }}
          >
            <SidebarPanel collapsed />
          </div>

          {/* Expanded overlay — slides in from left on hover */}
          <div
            className={`absolute top-0 left-0 h-full z-50 shadow-2xl overflow-y-auto transition-all duration-300 ease-in-out ${
              sidebarExpanded
                ? "opacity-100 translate-x-0 pointer-events-auto"
                : "opacity-0 -translate-x-full pointer-events-none"
            }`}
            style={{
              width: "250px",
              background: "linear-gradient(225deg, #1A0E3E 30%, #4F2A71 75%, #904DB0 100%)",
            }}
          >
            <SidebarPanel expanded />
          </div>
        </div>

        {/* Main content */}
        <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
          {/* Mobile top bar — only below md */}
          <div
            className="md:hidden flex items-center px-4 py-3 flex-shrink-0"
            style={{ background: "linear-gradient(180deg, #1A0E3E 0%, #4F2A71 100%)" }}
          >
            <MobileSidebar />
          </div>

          {/* Page content */}
          <div
            className={`flex-1 w-full ${
              location.pathname === "/chat" || location.pathname === "/translate" || location.pathname === "/transcribe"
                ? "flex flex-col py-3 lg:py-6 bg-[#F0EEF8] overflow-hidden min-h-0"
                : location.pathname === "/history"
                ? "flex flex-col p-3 lg:p-6 bg-[#F0EEF8] overflow-hidden min-h-0"
                : "flex items-center justify-center p-4 lg:p-10 bg-white"
            }`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}